export const SEARCH_PATH = 'search';
export const WEBSITE_NAME = 'MFlix';
